module.exports = __webpack_public_path__ + "static/media/BG_69.780bab5e.png";